/**
 * Created by rickborst on 25/04/2017.
 */

import _ from 'lodash';

/**
 * Converts meta data from read data.
 *
 * @param {Object} [data] - Read data.
 * @returns {Object} Meta data.
 */
export function convertFromRead (data = {}) {

    /* eslint-disable max-len */
    return {
        location: _.get(data, ['Game_location', 'value']) || _.get(data, ['Game location', 'value']) || '',
        houseNumber: _.get(data, ['House_number', 'value']) || _.get(data, ['House number', 'value']) || '',
        league: _.get(data, ['League_name', 'value']) || _.get(data, ['League name', 'value']) || '',
        priority: _.get(data, ['Priority', 'value']) || '',
        programType: _.get(data, ['Program_type', 'value']) || _.get(data, ['Program type', 'value']) || _.get(data, ['Program Type', 'value']) || '',
        sportType: _.get(data, ['Sport_type', 'value']) || _.get(data, ['Sport type', 'value']) || '',
        team1: _.get(data, ['Team_name', 'value']) || _.get(data, ['Team name', 'value']) || '',
        team2: _.get(data, ['Vs_Team_name', 'value']) || _.get(data, ['Vs Team name', 'value']) || '',
        broadcastType: _.get(data, ['broadcast_type', 'value']) || _.get(data, ['broadcast type', 'value']) || '',
        episodeNumber: _.get(data, ['episode-num', 'value']) || _.get(data, ['Episode Number', 'value']) || '',
        rating: _.get(data, ['rating', 'value']) || _.get(data, ['Parental Rating', 'value']) || '',
        seriesId: _.get(data, ['series-id', 'value']) || _.get(data, ['Series Id', 'value']) || '',
        seriesName: _.get(data, ['series-name', 'value']) || _.get(data, ['Series Name', 'value']) || '',
        subTitle: _.get(data, ['sub-title', 'value']) || ''
    };
    /* eslint-enable max-len */
}


// WEBPACK FOOTER //
// ./src/js/datasources/kaltura/adapters/assets/metadata.js